module.exports = __webpack_public_path__ + "static/media/details-30-image-3.743925a2.jpg";